$(function () {
  if ($("#testimonial-dropdown-display").length) {
    var app = new Vue({
      data: {
        dataUrl: "",
        dataAltUrl: "",
        areas: [],
        selectedArea: "",
        testimonials: [],
      },
      methods: {
        fetchData: function () {
          var self = this;
          $.get(self.dataUrl, function (data) {
            self.areas = data.areas;
          });
        },
        fetchTestimonials: function () {
          var self = this;
          self.testimonials = [];

          if (!_.isEmpty(self.selectedArea)) {
            $.get(
              self.dataAltUrl + "/?id=" + self.selectedArea,
              function (data) {
                self.testimonials = data.testimonials;
              }
            );
          }
        },
      },
      created: function () {
        var self = this;
        self.dataUrl = $("#testimonial-dropdown-display").data("source");
        self.dataAltUrl = $("#testimonial-dropdown-display").data("alt-source");
        var defaultArea = $("#testimonial-dropdown-display").data(
          "default-select"
        );

        if (self.dataUrl.length > 0) self.fetchData();

        if (defaultArea) {
          self.selectedArea = defaultArea;
          self.fetchTestimonials();
        }
      },
    });
    app.$mount("#testimonial-dropdown-display");
  }
});
